import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from "@router";
import { useAuth } from "@hooks/useAuth";
import { useLocation } from "react-router-dom";
import logoWhite from "@assets/images/logo-white.png";
import iscriLogoWhite from "@assets/images/iscri-logo-white.png";
import "./LoginPage.css";

/**
 * Login page component based on template_login.ts
 * Adapted to follow project rules and color scheme
 */
const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, loading, error, clearError } = useAuth();
  const [validationErrors, setValidationErrors] = useState({
    email: false,
    password: false,
  });

  /**
   * Handle form submission
   */
  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const email = formData.get("email");
    const password = formData.get("password");

    if (!validateInputs()) {
      return;
    }

    clearError();

    const success = await login({ email, password });

    if (success) {
      const from = location.state?.from || "/advanced";
      navigate(from, { replace: true });
    }
  };

  /**
   * Validate form inputs
   */
  const validateInputs = () => {
    const email = document.getElementById("email");
    const password = document.getElementById("password");

    const errors = { email: false, password: false };
    let isValid = true;

    if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
      errors.email = true;
      isValid = false;
    }

    if (!password.value || password.value.length < 6) {
      errors.password = true;
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  /**
   * Handle remember me checkbox
   */
  const handleRememberMe = () => {
    console.log("remember me");
  };

  /**
   * Handle forgot password link
   */
  const handleForgotPassword = (e) => {
    e.preventDefault();
    console.log("your forgot your password");
  };

  /**
   * Handle sign up link
   */
  const handleSignUp = (e) => {
    e.preventDefault();
    console.log("page sign up soon");
  };

  return (
    <div className="login-page">
      {/* Simplified header with only Back to templates */}
      <header className="login-header">
        <Link to={ROUTES.HOME} className="back-to-templates">
          ← Back to Home
        </Link>
      </header>

      {/* Login container */}
      <div className="login-container">
        <div className="login-card">
          {/* Partnership Logos */}
          <div className="login-logos">
            <img src={logoWhite} alt="Logo" className="partnership-logo" />
            <img
              src={iscriLogoWhite}
              alt="ISCRI Logo"
              className="partnership-logo"
            />
          </div>

          <h1 className="login-title">Sign in</h1>

          {/* Login form */}
          <form onSubmit={handleSubmit} className="login-form" noValidate>
            {/* Email field */}
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="your@email.com"
                autoComplete="email"
                autoFocus
                required
                className={`form-input ${
                  validationErrors.email || error ? "error" : ""
                }`}
              />
              {(validationErrors.email || error) && (
                <span className="error-message">
                  {validationErrors.email
                    ? "Please enter a valid email address."
                    : error}
                </span>
              )}
            </div>

            {/* Password field */}
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                id="password"
                type="password"
                name="password"
                placeholder="••••••"
                autoComplete="current-password"
                required
                className={`form-input ${
                  validationErrors.password || error ? "error" : ""
                }`}
              />
              {(validationErrors.password || error) && (
                <span className="error-message">
                  {validationErrors.password
                    ? "Password must be at least 6 characters long."
                    : error}
                </span>
              )}
            </div>

            {/* Remember me checkbox */}
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  onChange={handleRememberMe}
                  className="checkbox-input"
                />
                <span className="checkbox-text">Remember me</span>
              </label>
            </div>

            {/* Submit button */}
            <button
              type="submit"
              className={`login-button ${loading ? "loading" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="loading-spinner"></span>
                  Signing in...
                </>
              ) : (
                "Sign in"
              )}
            </button>

            {/* Forgot password link */}
            <a
              href="#"
              onClick={handleForgotPassword}
              className="forgot-password-link"
            >
              Forgot your password?
            </a>
          </form>

          {/* Sign up link */}
          <div className="signup-section">
            <span className="signup-text">
              Don't have an account?{" "}
              <a href="#" onClick={handleSignUp} className="signup-link">
                Sign up
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
